type InitOptions = {
  visibleSaveButton?: boolean;
  visiblePrintButton?: boolean;
};

export default class PDFJs {
  init(source: string, element: HTMLDivElement, options: InitOptions = {}) {
    const iframe = document.createElement("iframe");
    iframe.src = `/public/pdfjs-5.1.91-dist/web/viewer.html?file=${encodeURIComponent(
      source
    )}`;
    iframe.width = "100%";
    iframe.style.border = "none";

    const hiddenSelectors: string[] = [];
    if (!options.visibleSaveButton) {
      hiddenSelectors.push("#downloadButton", "#secondaryDownload");
    }
    if (!options.visiblePrintButton) {
      hiddenSelectors.push("#printButton", "#secondaryPrint");
    }

    if (hiddenSelectors.length > 0) {
      iframe.addEventListener("load", () => {
        const doc = iframe.contentDocument;
        if (!doc) return;

        const style = doc.createElement("style");
        (style as Node).textContent = `${hiddenSelectors.join(
          ", "
        )} { display: none !important; }`;
        (doc.head as Node | null)?.appendChild(style);
      });
    }

    ((element as unknown) as Node).appendChild(iframe);
  }
}
